const React = require('react');
const trim = require('mn-utils/trim');
const {default: TextField} = require('@material-ui/core/TextField');
const inputCtor = require('../../utils/inputCtor');

const LabelDisplay = require('../LabelDisplay');
const ErrorDisplay = require('../ErrorDisplay');
const handleChanges = require("../../utils/handleChanges");

const Input = ({
  id,
  name,
  type,
  onChange,
  onChangeHandlers,
  value,
  disabled,
  endAdornment,
  showError
}) => (
  <TextField
    id={id}
    name={name}
    type={type || 'text'}
    onChange={handleChanges({name, onChange, onChangeHandlers})}
    value={value || ''}
    disabled={disabled}
    margin="none"
    variant="standard"
    className={`
        w
        (o30|c0)>.MuiInputBase-root.Mui-disabled
        (bgF|b1|bs|bc0|r9)>.MuiInputBase-root
        (bcF00).error>.MuiInputBase-root
        (bc0|r9)>.MuiInputBase-root.Mui-focused
        (hmin45|pt12|ph25|pb15|bxzBB|f12|fw7|ff$3|dn)>.MuiInputBase-input          
        ` + (showError ? ' error' : '')
    }
    InputProps={{
      endAdornment,
      disableUnderline: true,
    }}
  />
);

const Component = ({
  className,
  labelProps,
  inputProps,
  errorProps
}) => (
  <div
    className={'rlv ' + (className || '')}
  >
    <LabelDisplay {...labelProps} />
    <Input {...inputProps} />
    <ErrorDisplay {...errorProps} />
  </div>
)

module.exports = inputCtor(Component);
